import { Component, inject, OnInit } from '@angular/core';
import { IonCard, IonLabel, IonIcon, IonButton } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { GeneralActions } from '@hunting-nature/Secacam/shared/redux/general/general.actions';
import { SubscriptionTypeComponent } from '@hunting-nature/shared-ui/components/subscription-type/subscription-type.component';
import { SubscriptionSlotUsageComponent } from '@hunting-nature/shared-ui/components/subscription-slots-usage/subscription-slot-usage.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import { MenuActions } from '../redux/menu.action';
import { MenuSelectors } from '../redux/menu.reducer';

@Component({
  selector: 'app-menu-subscription-card',
  imports: [IonButton, IonIcon, IonLabel, IonCard, TranslocoPipe, SubscriptionTypeComponent, SubscriptionSlotUsageComponent, AppButtonComponent],
  templateUrl: './menu-subscription-card.html',
  styleUrl: './menu-subscription-card.scss',
})
export class MenuSubscriptionCard implements OnInit {
  // services
  private readonly store = inject(Store);

  // UI bindings
  protected readonly type$$ = this.store.selectSignal(MenuSelectors.subscriptionType);
  protected readonly isPrepaid$$ = this.store.selectSignal(MenuSelectors.isPrepaid);
  protected readonly imageCredits$$ = this.store.selectSignal(MenuSelectors.imageCredits);
  protected readonly unlimitedImageCredits$$ = this.store.selectSignal(MenuSelectors.unlimitedImageCredits);
  protected readonly videoCredits$$ = this.store.selectSignal(MenuSelectors.videoCredits);
  protected readonly prepaidCredits$$ = this.store.selectSignal(MenuSelectors.prepaidCredits);
  protected readonly isLowPrepaidCredits$$ = this.store.selectSignal(MenuSelectors.lowPrepaidCredits);
  protected readonly isLowVideoCredits$$ = this.store.selectSignal(MenuSelectors.lowVideoCredits);
  protected readonly isLowImageCredits$$ = this.store.selectSignal(MenuSelectors.lowImageCredits);
  protected readonly isEmptyPrepaidCredits$$ = this.store.selectSignal(MenuSelectors.emptyPrepaidCredits);
  protected readonly assignedCamerasCount$$ = this.store.selectSignal(MenuSelectors.assignedCamerasCount);
  protected readonly cameraSlots$$ = this.store.selectSignal(MenuSelectors.cameraSlots);

  // initialization
  ngOnInit() {
    this.store.dispatch(MenuActions.subscriptionCardEntered());
  }

  // handlers
  handleAddCredits() {
    this.store.dispatch(MenuActions.openAddCreditsSite());
  }

  handleManagePlanAndCredits() {
    this.store.dispatch(GeneralActions.goToMenuSubscriptionsAndPlans());
  }
}
